const styles = {
    bold: {
        fontWeight: 'bold'
    }
};

export default styles;
